import { makeStyles, createStyles, IconButton } from '@material-ui/core';
import { useContext, FC, ChangeEvent } from 'react';
import { FormContext, FormControlProps, registry } from '..';
import { AddPhotoAlternate } from '@material-ui/icons';
import { grey } from '@material-ui/core/colors';
import { FileImportControlDefinition, parseFieldIdentifier } from '../services';
import { delayedUploadImageActions } from '../../../../redux';
import React from 'react';
import 'react-html5-camera-photo/build/css/index.css';
import { useDispatch } from 'react-redux';
import { v4 as uuidv4 } from 'uuid';
require('./ImageCapture.css');
export interface FileImportProps extends FormControlProps<FileImportControlDefinition> {
}

const useStyles = makeStyles(function (e) {
  return createStyles({
    root: { alignSelf: 'center' },
    toolbar: { backgroundColor: 'rgba(a,a,a,2)' },
    cameraBox: { height: '100%', width: '100%', overflow: 'hidden', backgroundColor: 'rgb(0,0,0)' },
    closeButton: { position: 'absolute', top: 0, left: e.spacing(3), color: grey[50] },
    imageWrapper: { width: '100%', height: '100%' },
    image: { display: 'block', marginLeft: 'auto', marginRight: 'auto', maxWidth: '100%', maxHeight: '100%', height: 'auto' },
    confirmBox: { position: 'absolute', width: '100%', bottom: 0, display: 'flex', height: '44px' },
    confirmButton: { flex: 1, backgroundColor: grey[900], opacity: 0.8, color: grey[50], borderRadius: 0, '&:hover': { backgroundColor: grey[600] } },
  });
});
export const FileImport: FC<FileImportProps> = function(props) {
  const t = props.definition;
  const classes = useStyles({});
  const { scope, evalID } = useContext(FormContext);
  const dispatch = useDispatch();

  function onUpload(files: FileList | null) {
    if (!files) {
      return;
    }
    const reader = new FileReader();
    reader.onload = function () {
      dispatch(delayedUploadImageActions.request({ id: uuidv4(), uri: reader.result as string, scope: scope, evalID: evalID as string, path: '{' + parseFieldIdentifier(t.dataPath) + '/-}' }));
    };
    reader.readAsDataURL(files[0]);
  }
  function renderButtons() {
    const inputRef = React.createRef<HTMLInputElement>();

    return (
      <div className = { classes.root }>
        <input
          accept = { 'application/pdf, application/json, image/*' }
          id = { 'upload-button' }
          type = { 'file' }
          onChange = { (e: ChangeEvent<HTMLInputElement>) => onUpload(e.target.files) }
          hidden = { true }
          ref = { inputRef }>
        </input>
        <IconButton
          onClick = { () => inputRef?.current?.click() }>
          <AddPhotoAlternate></AddPhotoAlternate>
        </IconButton>
      </div>
    );
  }
  return renderButtons();
};
registry.registerComponent('FileImport', FileImport);
